module.exports = __webpack_public_path__ + "media/images/level_introduction_header-2a078f59014e4d98271e02b771cf409a.png";